import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  fullWidth: {
    width: "100%",
  },
}));

export default useStyles;
